module.exports = require("./pa-Arab.d.ts");